import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateHomeHero(section, textLines) {

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 90%",
    },
  });

  tl.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    }
  });

}